module.exports = __webpack_public_path__ + "static/img/portinfo1.d2a3fd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/portinfo1.png
// module id = HBVC
// module chunks = 0